import { put, fork, call, takeEvery, all, select } from 'redux-saga/effects';
import app from '../../app';
import {
  loadBankCardListCompletion,
  loadBankCardInfoCompletion,
  loadBankNameListCompletion,
  loadBankProvinceListCompletion,
  loadBankCityListCompletion,
  saveBankCardCompletion,
  unBindBankCardCompletion,
  catchError,
} from '../../actions';

export function* watchLoadBankCardList() {
  yield takeEvery('LOAD_BANK_CARD_LIST', function*() {
    const options = {
      url: '/api/b/wallet/card/list',
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadBankCardListCompletion(result.data, result.error));
  });
}

export function* watchLoadBankCardInfo() {
  yield takeEvery('LOAD_BANK_CARD_INFO', function*(action) {
    const cardId = action.cardId;
    const options = {
      url: `/api/b/wallet/card/check?cardNo=${cardId}`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadBankCardInfoCompletion(cardId, result.data, result.error));
  });
}

export function* watchLoadBankNameList() {
  yield takeEvery('LOAD_BANK_NAME_LIST', function*() {
    const options = {
      url: '/api/b/wallet/card/company/list',
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadBankNameListCompletion(result.data, result.error));
  });
}

export function* watchLoadBankProvinceList() {
  yield takeEvery('LOAD_BANK_PROVINCE_LIST', function*() {
    const options = {
      url: '/api/address/province',
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadBankProvinceListCompletion(result.data, result.error));
  });
}

export function* watchLoadBankCityList() {
  yield takeEvery('LOAD_BANK_CITY_LIST', function*(action) {
    const provinceId = action.provinceId;
    const options = {
      url: `/api/address/city/${provinceId}`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(
      loadBankCityListCompletion(provinceId, result.data, result.error)
    );
  });
}

export function* watchSaveBankCard() {
  yield takeEvery('SAVE_BANK_CARD', function*({
    name,
    cardId,
    cardCompany,
    provinceName,
    cityName,
    idCard,
    idCardImgFront,
    idCardImgOpposite,
    code,
  }) {
    let error;
    const trimmedName = (name || '').trim();
    const trimmedCardId = (cardId || '').trim();
    const trimmedIdCard = (idCard || '').trim();
    if (!trimmedCardId) {
      error = new Error('请输入银行卡号');
    } else if (!trimmedName) {
      error = new Error('请输入姓名');
    } else if (!trimmedIdCard) {
      error = new Error('请输入证件号');
    } else if (!cardCompany) {
      error = new Error('请选择开户行');
    } else if (!idCardImgFront) {
      error = new Error('请上传身份证照片面');
    } else if (!idCardImgOpposite) {
      error = new Error('请上传身份证国徽面');
    } else if (!code) {
      error = new Error('请输入验证码');
    }
    if (error) {
      yield put(catchError(error));
      yield put(saveBankCardCompletion(undefined, error));
      return;
    }
    const options = {
      url: '/api/b/wallet/card/add',
      method: 'POST',
      data: {
        name: trimmedName,
        cardNo: trimmedCardId,
        cardCompany,
        provinceName,
        cityName,
        idCard: trimmedIdCard,
        idCardImgFront,
        idCardImgOpposite,
        code,
      },
    };
    const result = yield call(app.httpFetch, options);

    if (!result.error) {
      // app.showTips('succ', '设置银行卡成功');
      app
        .showConfirm({
          title: '实名认证成功',
          doneTitle: '去签署',
          cancelTitle: '返回',
          succIcon: true,
          message:
            '已根据您的申请为您注册审核并颁发实名认证数字证书，可以签署委托书啦！',
        })
        .then(res => {
          if (res.done) {
            app.redirectTo('/member/agent/esign/edit');
            app.dispatch(saveBankCardCompletion(result.data, result.error));
          }
          if (res.cancel) {
            app.redirectTo('/mine');
            app.dispatch(saveBankCardCompletion(result.data, result.error));
          }
        });
    } else {
      app.dispatch(saveBankCardCompletion(result.data, result.error));
      // app
      //   .showConfirm({
      //     title: '提示',
      //     message:
      //       result.error?.message ||
      //       '您的银行卡号预留信息与实名信息不一致，请先修改再授权。',
      //     cancelable: false,
      //     doneTitle: '去修改',
      //   })
      //   .then(res => {
      //     if (res.done) {
      //     }
      //   });
    }
  });
}

export function* watchUnBindBankCard() {
  yield takeEvery('UNBIND_BANK_CARD', function*({ pwd }) {
    const { list = null } = yield select(state => state.own.bankCard.master);

    let error;
    if (!list || (list && list.length === 0)) {
      error = new Error('银行卡信息出错，请返回重试！');
      yield put(catchError(error));
      yield put(unBindBankCardCompletion(error));
      return;
    }

    const { walletCardId } = list[0];
    if (!walletCardId) {
      error = new Error('银行卡信息出错，请返回重试！');
      yield put(catchError(error));
      yield put(unBindBankCardCompletion(error));
      return;
    }

    const options = {
      url: '/api/b/wallet/card/unbind',
      method: 'POST',
      data: {
        password: pwd,
        walletCardId,
      },
    };
    const result = yield call(app.httpFetch, options);
    if (!result.error) {
      app.showTips('succ', '解绑成功！');
    }

    yield put(unBindBankCardCompletion(result.error));
  });
}

export default function* bankCardSaga() {
  yield all([
    fork(watchLoadBankCardInfo),
    fork(watchLoadBankNameList),
    fork(watchLoadBankProvinceList),
    fork(watchLoadBankCityList),
    fork(watchSaveBankCard),
    fork(watchLoadBankCardList),
    fork(watchUnBindBankCard),
  ]);
}
